// App.js
import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Navbar from "../Components/Navbar";
import LandingPage from "../Routes/LandingPage";
import OurProductsPage from "../Routes/OurProductsPage";
import ContactUsPage from "../Routes/ContactUsPage";
import ProjectDetail from "../Components/Version2/website/projectDetails";
import AIMLDetailPage from "../Components/Version2/website/aiMLDetailPage";
import FinTechDetailPage from "../Components/Version2/website/fintechDetailPage";
import Footer from "../Components/Footer";
import PdfViewer from "../Components/PDFViewer";
import ScrollToTop from "../Components/ScrollToTop";
import SnackbarProvider from 'react-simple-snackbar'
import { createGlobalStyle } from "styled-components";
import { COLORS } from "../Constants/colors";

const GlobalStyle = createGlobalStyle`
  .swiper-button-next,
  .swiper-button-prev {
    color: ${COLORS.secondary};
  }

  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    color: ${COLORS.primary};
  }
  .swiper-pagination-bullet {
    background-color: ${COLORS.textPrimary};
  }
    .swiper-pagination-bullet-active {
    background-color: ${COLORS.secondary};
  }
`;

const App = () => {
  return (
    <BrowserRouter>
    <SnackbarProvider>
      <GlobalStyle/>
      <Routes>
        {/* Navbar is common for all routes except /portfolio */}
        <Route
          path="/*"
          element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/products" element={<OurProductsPage />} />
                <Route path="/contact-us" element={<ContactUsPage />} />
                <Route path="/projects/:id" element={<ProjectDetail />} /> 
                <Route path="/ai" element={<AIMLDetailPage />} /> 
                <Route path="/fintech" element={<FinTechDetailPage />} /> 
              </Routes>
              <Footer />
              <ScrollToTop/>
            </>
          }
        />
        
        {/* /portfolio route without Navbar and Footer */}
        <Route path="/portfolio.pdf" element={<PdfViewer />} /> 
      </Routes>
      </SnackbarProvider>
    </BrowserRouter>
  );
};

export default App;
